// Action types
export const FETCH_PRICING_REQUEST = 'FETCH_PRICING_REQUEST'
export const FETCH_PRICING_SUCCESS = 'FETCH_PRICING_SUCCESS'
export const FETCH_PRICING_FAILURE = 'FETCH_PRICING_FAILURE'

// Initial state
const initialState = {
  data: null, // { region, currency, currency_symbol, symbol_position, payment_provider, plans: [...] }
  loading: false,
  error: null,
}

// Reducer
const pricingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRICING_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_PRICING_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null }
    case FETCH_PRICING_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default pricingReducer
